import { render, staticRenderFns } from "./LoggedUserButton.vue?vue&type=template&id=8dd04dc8&scoped=true"
import script from "./LoggedUserButton.vue?vue&type=script&lang=js"
export * from "./LoggedUserButton.vue?vue&type=script&lang=js"
import style0 from "./LoggedUserButton.vue?vue&type=style&index=0&id=8dd04dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd04dc8",
  null
  
)

export default component.exports